import { render, staticRenderFns } from "./AgentReview.vue?vue&type=template&id=2e4bd694&scoped=true"
import script from "./AgentReview.vue?vue&type=script&lang=js"
export * from "./AgentReview.vue?vue&type=script&lang=js"
import style0 from "./AgentReview.vue?vue&type=style&index=0&id=2e4bd694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bd694",
  null
  
)

export default component.exports